import { SET_REVIEWS } from './types';

/**
 * @param {Array<Review>} reviews
 * @returns {Object} action
 * @returns {string} action.type - SET_REVIEWS
 * @returns {Array<Review>} action.payload - reviews
 */
export const setReviews = (reviews) => {
	return {
		type: SET_REVIEWS,
		payload: reviews
	};
};
